import "core-js/modules/es6.string.link";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    // moreStr: {
    //     type: String,
    // },
    lessStr: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: '#'
    },
    maxChars: {
      type: Number,
      default: 100
    },
    isReadMore: {
      type: Boolean,
      default: false
    },
    btnColor: {
      type: String,
      default: 'teal'
    },
    showScrollbar: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {// isReadMore: false
    };
  },
  computed: {
    formattedString: function formattedString() {
      var valContainer = this.text;

      if (!this.isReadMore && this.text.length > this.maxChars) {
        valContainer = valContainer.substring(0, this.maxChars) + '...';
      }

      return valContainer;
    }
  },
  methods: {
    triggerReadMore: function triggerReadMore(e, b) {
      if (this.link === '#') {
        e.preventDefault();
      }

      if (this.lessStr !== null || this.lessStr !== '') {
        this.isReadMore = b;
      }
    }
  }
};